export default __webpack_public_path__ + "static/media/8b58ea92c875c64fe2ed9bd3196a01ef1581605585924.6bc33cf6.webp";